export const transitions = {
  'with-transition': {
    transition: '0.2s ease all',
  },
  'with-long-transition': {
    transition: '0.3s ease all',
  },
};
